import {useDispatch, useSelector} from 'react-redux';
import LoginRoute from './pages/login';
import AppRouter from './Router';
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer} from 'react-toastify';
import Loader from "./components/Loader";
import {useEffect} from "react";
import {isUserLoggedIn} from "./helpers/helperFunctions";
import {tryGetUsersProfile} from "./redux/slices/authTokenSlice";

function App() {
  const {user, appLoading: {loading}} = useSelector((state) => state.authToken);
  const dispatch = useDispatch();

  useEffect(
    () => {
      if (isUserLoggedIn()) {
        dispatch(tryGetUsersProfile());
      }
    }, []
  );

  return (
    <>
      <ToastContainer
        autoClose={5500}
        position="top-right"
        closeButton={false}
      />
      {!!user ? (
          <AppRouter/>
        )
        //   : token?.role === 'pharmacist' ? (
        //   <PharmacyAdminRouter/>
        // )

        : (
          <LoginRoute/>
        )}
      {loading && <Loader/>}
    </>
  );
}

export default App;
